import { PlusCircleOutlined } from "@ant-design/icons";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withKeycloak } from "@react-keycloak/web";
import React from "react";
import { withRouter } from "react-router";
import { labels } from "../../../../../localization/labels";
import KnowledgeService from "../../../../../services/KnowledgeService";
import { constants } from "../../../../../utils/Constants";
import PathUtil from "../../../../../utils/PathUtil";
import SecurityUtils from "../../../../../utils/SecurityUtils";
import TableUtils from "../../../../core/Table/TableUtils";
import { paths } from "../../../../paths";
import PageComponent from "../../../page/PageComponent";
import SimilarKnowledge from "./SimilarKnowledge";

class SimilarKnowledgeContainer extends PageComponent {
  constructor(props) {
    super(props);

    this.knowledgeService = new KnowledgeService(this.keycloak);
    this.state = {
      content: [],
      contextMenuItems: [
        {
          label: labels.newTab,
          callback: this.openInNewTab,
          menuItemType: constants.MENU_ITEM_TYPE_NEW_TAB,
          checkSecurity: true,
          icon: (
            <FontAwesomeIcon className="contextIcon" icon={faExternalLinkAlt} />
          )
        }
      ]
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    const url = this.props.knowledgeItem._links.similarKnowledges.href;
    this.prepareCall(
      this.knowledgeService.getEntitiesByUrl(
        url,
        this.onDataLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onDataLoad = data => {
    this.setState({
      content: data?._embedded?.content || [],
      isLoading: false,
      showTable: true
    });
  };

  onAdd = data => {
    this.props.addSimilarKnowledge && this.props.addSimilarKnowledge(data);
  };

  columns = [
    {
      dataField: "id",
      text: labels.id,
      classes: "column-id",
      headerClasses: "column-header-id",
      formatter: TableUtils.selectableTextFormatter,
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) =>
          this.onRowClick(e, row)
      }
    },
    {
      dataField: "name",
      text: labels.name,
      headerClasses: "column-header",
      formatter: TableUtils.selectableTextFormatter,
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) =>
          this.onRowClick(e, row)
      }
    },
    {
      dataField: "description",
      text: labels.description,
      headerClasses: "column-header",
      formatter: TableUtils.selectableTextFormatter,
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) =>
          this.onRowClick(e, row)
      }
    },
    {
      dataField: "action",
      isDummyField: true,
      text: labels.actions,
      headerClasses: "column-header-id",
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => this.onAdd(row)
      },
      formatter: (cellContent, row) => (
        <div className="column-id selectable">
          <PlusCircleOutlined
            className="add-icon-table"
            title={labels.addToRelationship}
          />
        </div>
      )
    }
  ];

  getComponentTitle = () => {
    return labels.similarKnowledgeItems;
  };

  onRowClick = (_, row) => {
    if (
      SecurityUtils.partyHasPermissionOnEntity(row, constants.OPERATION_READ)
    ) {
      const itemPath = PathUtil.itemPath(paths.KNOWLEDGE_ITEM, row.id);
      this.changePath(itemPath, row.name);
    } else return undefined;
  };

  openInNewTab = row => {
    if (
      SecurityUtils.partyHasPermissionOnEntity(row, constants.OPERATION_READ)
    ) {
      const itemPath = PathUtil.itemPath(paths.KNOWLEDGE_ITEM, row.id);
      window.open(itemPath, "_blank", "noopener");
    } else return undefined;
  };

  render() {
    return (
      <SimilarKnowledge
        columns={this.columns}
        data={this.state.content}
        contextMenuItems={this.state.contextMenuItems}
      />
    );
  }
}

export default withKeycloak(withRouter(SimilarKnowledgeContainer));
